export default __webpack_public_path__ + "static/media/Scott-Geleas-Resume.8c3cfb94.pdf";